/* eslint-disable indent */
// @flow
import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { Button } from 'semantic-ui-react';
import * as cssCmviq from './DoTransferComviq.module.css';
import * as cssTele2 from './DoTransferTele2.module.css';
import Header from '../Header';
import Loading, { Spinner } from 'components';
import Hero from '../Hero';
import { useSelector } from 'react-redux';
import { isComviqCustomer } from '../../helpers/customerTypeHelpers';
import supportContactDetails from 'assets/content/customerSupportContactDetails.json';

type Props = {
  onDoTransfer: () => Any,
  onCancel: () => null,
  hasUncompletedTransfer: boolean,
};

const DoTransfer = ({ onDoTransfer, onCancel, hasUncompletedTransfer }: Props) => {
  const [transferSent, setTransferSent] = useState(false);
  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);

  const css = isComviq ? cssCmviq : cssTele2;
  const brand = isComviq ? 'Comviqs' : 'Tele2s';
  const customerServicePhoneNumber = supportContactDetails.phoneNumber[String(customerType)];

  const handleDoTransfer = () => {
    onDoTransfer();
    setTransferSent(true);
  };

  if (!css) return <Loading />;
  return (
    <>
      <Header />
      {isComviq && <Hero />}
      <div className={css.container}>
        <div className={css.card}>
          <div className={css.content}>
            {isComviq && (
              <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M28.5 56C43.964 56 56.5 43.464 56.5 28C56.5 12.536 43.964 0 28.5 0C13.036 0 0.5 12.536 0.5 28C0.5 43.464 13.036 56 28.5 56Z"
                  fill="#939393"
                />
                <path
                  d="M31.0538 7C32.1566 7 33.0067 7.32432 33.604 7.97297C34.2013 8.62162 34.5 9.45045 34.5 10.4595C34.5 11.6607 34.052 12.7177 33.156 13.6306C32.26 14.5435 31.1687 15 29.8822 15C28.7794 15 27.9293 14.6877 27.332 14.0631C26.7347 13.4384 26.459 12.5736 26.5049 11.4685C26.5049 10.3634 26.907 9.34234 27.7111 8.40541C28.5152 7.46847 29.6294 7 31.0538 7Z"
                  fill="white"
                />
                <path
                  d="M24.2609 45C22.087 45 21.5 42.9918 22.5 38.9754L24.4565 30.3785C24.7609 29.1149 24.7609 28.4831 24.4565 28.4831C24.1957 28.4831 23.6087 28.6862 22.6957 29.0923C21.7826 29.4985 21 29.9272 20.3478 30.3785L19.5 28.8892C21.4565 27.1292 23.5109 25.7077 25.663 24.6246C27.8152 23.5415 29.4565 23 30.587 23C32.2826 23 32.6739 24.8277 31.7609 28.4831L29.4783 37.4862C29.1304 38.9303 29.1957 39.6523 29.6739 39.6523C30.6304 39.6523 31.913 38.9754 33.5217 37.6215L34.5 38.9754C32.6739 40.9159 30.7717 42.4051 28.7935 43.4431C26.8152 44.481 25.3043 45 24.2609 45Z"
                  fill="white"
                />
              </svg>
            )}
            {hasUncompletedTransfer ? (
              <>
                <h2 className={css.title}>Pågående flytt</h2>
                <p className={css.text}>
                  {`Du har påbörjat en flytt av abonnemang till den här klockan. Slutför den eller ring ${brand} kundservice på tel ${customerServicePhoneNumber} för att ångra.`}
                </p>
              </>
            ) : (
              <>
                <h2 className={css.title}>Är du säker?</h2>
                <p className={css.text}>
                  När du flyttar abonnemanget till ny klocka så kommer det inte längre fungera med tidigare klockor.{' '}
                </p>
              </>
            )}
          </div>
          <div className={css.footer}>
            {transferSent && <Spinner className={css.loader} />}
            <Button className={css.btnLink} onClick={onCancel} disabled={transferSent}>
              Avbryt
            </Button>
            <Button className={css.btnLink} onClick={handleDoTransfer} disabled={transferSent}>
              Fortsätt
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(DoTransfer);
